"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstanceNodeBinding = getInstanceNodeBinding;
function getInstanceNodeBinding(node) {
    return node.binding;
}
//# sourceMappingURL=getInstanceNodeBinding.js.map